export default __webpack_public_path__ + "static/luottokorttipuhelin-8ebdbca6d8e1190668db10cc5ec8e910.svg";